module.exports = __webpack_public_path__ + "img/KES.ae5fb70b.svg";